export const translations = {
  en: {
    langName: "English",
    titleLine2: "Digital Service Contract",
    heroDescription:
      "A formal agreement defining the premium digital systems and AI automation services to be provided by Zaynar Systems, based in Barcelona, Catalunya, Spain.",
    contractDateLabel: "Contract Date",
    servicesOverline: "Selected Services",
    servicesTitle: "Scope of Engagement",
    servicesIntro:
      "Website Development is the mandatory core service of this Agreement. You may enhance your engagement with optional add-on services below.",
    mandatoryBadge: "Mandatory Core Service",
    optionalOverline: "Optional Additional Services",
    monthlyOverline: "Ongoing Partnership",
    monthlyTitle: "Monthly Support & Growth",
    monthlyAccepted: "Accepted — included in this Agreement",
    partiesOverline: "Parties to the Agreement",
    clientTitle: "Client Information",
    clientIntro:
      "All fields are required. The Client is responsible for providing accurate and complete information.",
    fullNameLabel: "Full Legal Name",
    fullNamePlaceholder: "e.g. John Alexander Smith",
    companyLabel: "Company Name",
    companyPlaceholder: "e.g. Smith Holdings Ltd.",
    emailLabel: "Email Address",
    emailPlaceholder: "you@company.com",
    phoneLabel: "Phone Number",
    phonePlaceholder: "+34 600 000 000",
    termsOverline: "Legal Terms",
    termsTitle: "Terms and Conditions",
    signatureOverline: "Electronic Signature",
    signatureTitle: "Signature & Acceptance",
    signaturePlaceholder: "Draw your signature here",
    clearSignature: "Clear Signature",
    submit: "Sign & Submit Contract",
    submitting: "Generating Contract…",
    submitNote:
      "Your signed contract is generated as a PDF and securely delivered to Zaynar Systems.",
    footer: "Barcelona, Catalunya, Spain",
    successTitle: "Contract Submitted",
    downloadPdf: "View Signed Contract (PDF)",
    referenceLabel: "Reference",
    errFullName: "Full legal name is required",
    errCompany: "Company name is required",
    errEmailRequired: "Email is required",
    errEmailInvalid: "Please enter a valid, deliverable email",
    errEmailVerify: "Email could not be verified",
    errPhoneRequired: "Phone number is required",
    errPhoneInvalid: "Please enter a valid phone number (include country code)",
    errPhoneVerify: "Phone could not be verified",
    toastLoad: "Unable to load contract details. Please refresh.",
    toastFields: "Please complete all required fields with valid information.",
    toastSignature: "A drawn signature is required to proceed.",
    toastAgreement: "You must confirm acceptance of the agreement.",
    toastSubmitFail: "Submission failed. Please try again.",
  },
  es: {
    langName: "Español",
    titleLine2: "Contrato de Servicios Digitales",
    heroDescription:
      "Un acuerdo formal que define los sistemas digitales premium y los servicios de automatización con IA que prestará Zaynar Systems, con sede en Barcelona, Cataluña, España.",
    contractDateLabel: "Fecha del Contrato",
    servicesOverline: "Servicios Seleccionados",
    servicesTitle: "Alcance del Compromiso",
    servicesIntro:
      "El Desarrollo Web es el servicio principal obligatorio de este Acuerdo. Puede ampliar su contratación con los servicios adicionales opcionales que se indican a continuación.",
    mandatoryBadge: "Servicio Principal Obligatorio",
    optionalOverline: "Servicios Adicionales Opcionales",
    monthlyOverline: "Colaboración Continua",
    monthlyTitle: "Soporte y Crecimiento Mensual",
    monthlyAccepted: "Aceptado — incluido en este Acuerdo",
    partiesOverline: "Partes del Acuerdo",
    clientTitle: "Información del Cliente",
    clientIntro:
      "Todos los campos son obligatorios. El Cliente es responsable de proporcionar información exacta y completa.",
    fullNameLabel: "Nombre Legal Completo",
    fullNamePlaceholder: "p. ej. Juan Alejandro García",
    companyLabel: "Nombre de la Empresa",
    companyPlaceholder: "p. ej. García Holdings S.L.",
    emailLabel: "Correo Electrónico",
    emailPlaceholder: "tu@empresa.com",
    phoneLabel: "Número de Teléfono",
    phonePlaceholder: "+34 600 000 000",
    termsOverline: "Términos Legales",
    termsTitle: "Términos y Condiciones",
    signatureOverline: "Firma Electrónica",
    signatureTitle: "Firma y Aceptación",
    signaturePlaceholder: "Dibuje su firma aquí",
    clearSignature: "Borrar Firma",
    submit: "Firmar y Enviar Contrato",
    submitting: "Generando Contrato…",
    submitNote:
      "Su contrato firmado se genera en formato PDF y se entrega de forma segura a Zaynar Systems.",
    footer: "Barcelona, Cataluña, España",
    successTitle: "Contrato Enviado",
    downloadPdf: "Ver Contrato Firmado (PDF)",
    referenceLabel: "Referencia",
    errFullName: "El nombre legal completo es obligatorio",
    errCompany: "El nombre de la empresa es obligatorio",
    errEmailRequired: "El correo electrónico es obligatorio",
    errEmailInvalid: "Introduzca un correo electrónico válido y operativo",
    errEmailVerify: "No se pudo verificar el correo electrónico",
    errPhoneRequired: "El número de teléfono es obligatorio",
    errPhoneInvalid: "Introduzca un número de teléfono válido (incluya el código de país)",
    errPhoneVerify: "No se pudo verificar el teléfono",
    toastLoad: "No se pudieron cargar los datos del contrato. Actualice la página.",
    toastFields: "Complete todos los campos obligatorios con información válida.",
    toastSignature: "Se requiere una firma dibujada para continuar.",
    toastAgreement: "Debe confirmar la aceptación del acuerdo.",
    toastSubmitFail: "El envío ha fallado. Inténtelo de nuevo.",
  },
};
